import { get } from 'lodash';

import { Income, StoreEmployment, Asset, FormValuesIncomesExpenses, Company } from '@funnels/types';
import { FIELD_PATHS, INCOME_TYPE } from '@funnels/constants';
import getFieldValueLabel from './getFieldValueLabel';

export default function getIncomeRelatedInfo(income: Income, formValues: FormValuesIncomesExpenses) {
  const type = get({ incomes: [income] }, FIELD_PATHS.INCOME_TYPE(0));
  const assets = get(formValues, FIELD_PATHS.ASSETS());
  const employments = get(formValues, FIELD_PATHS.EMPLOYMENTS());
  const companies = get(formValues, FIELD_PATHS.COMPANIES(), []);

  let relatedInfo;
  switch (type) {
    case INCOME_TYPE.PAYG_ALLOWANCES_NOT_TAXED:
    case INCOME_TYPE.PAYG_ALLOWANCES_TAXED:
    case INCOME_TYPE.PAYG_BASE_SALARY:
    case INCOME_TYPE.PAYG_BONUS_INCOME:
    case INCOME_TYPE.PAYG_CAR_ALLOWANCE:
    case INCOME_TYPE.PAYG_COMMISSION_INCOME:
    case INCOME_TYPE.PAYG_COMPANY_CAR:
    case INCOME_TYPE.PAYG_NON_VOLUNTARY_DEDUCTIONS_PRE_TAX:
    case INCOME_TYPE.PAYG_OVERTIME_INCOME:
    case INCOME_TYPE.PAYG_SALARY_SACRIFICE:
    case INCOME_TYPE.SELF_EMPLOYED_BUSINESS_INCOME:
    case INCOME_TYPE.SELF_EMPLOYED_BUSINESS_INCOME_FULL_DOC:
    case INCOME_TYPE.SELF_EMPLOYED_BUSINESS_INCOME_LOW_DOC:
      const employmentId = get({ incomes: [income] }, FIELD_PATHS.INCOME_EMPLOYMENT_ID(0));
      const employmentIndex = employments.findIndex(
        (employment: StoreEmployment) => employment.clientId === employmentId
      );
      const employmentName = get({ employments }, FIELD_PATHS.EMPLOYMENT_BUSINESS_NAME(employmentIndex));

      // SE v2 incomes
      const companyClientId = get({ incomes: [income] }, FIELD_PATHS.INCOME_COMPANY_CLIENT_ID(0));
      const company = companies.find(
        (company: Company) => get({ companies: [company] }, FIELD_PATHS.COMPANY_CLIENT_ID(0)) === companyClientId
      );
      const companyBusinessName = get({ companies: [company] }, FIELD_PATHS.COMPANY_BUSINESS_NAME(0));

      relatedInfo = companyBusinessName || employmentName;
      break;
    case INCOME_TYPE.RENTAL_INCOME:
      const assetId = get({ incomes: [income] }, FIELD_PATHS.INCOME_ASSET_ID(0));
      const assetIndex = assets.findIndex((asset: Asset) => asset.clientId === assetId);
      const propertyAddress = get({ assets }, FIELD_PATHS.ASSET_FORMATTED_ADDRESS(assetIndex));
      relatedInfo = propertyAddress;
      break;
    case INCOME_TYPE.GOVT_BENEFIT:
      const benefitType = getFieldValueLabel(get({ incomes: [income] }, FIELD_PATHS.INCOME_BENEFIT_TYPE(0)));
      relatedInfo = benefitType;
      break;
  }
  return relatedInfo;
}
